module.exports = __webpack_public_path__ + "static/media/SING-Newcastle.f73f4bac.jpg";